import { Theme } from '@mui/system'
import {
  hexToRgb,
  whiteColor,
} from '../../materialUI/jss/material-dashboard-pro-react'

const pagesStyle = {
  wrapper: {
    height: 'auto',
    minHeight: 'var(--app-vh)',
    position: 'relative',
    top: '0',
  },
  fullPage: (theme: Theme) => ({
    // backgroundImage: theme?.pages?.loginPage?.backgroundImage,
    backgroundImage: theme.pages.loginPage.backgroundImage,
    padding: '120px 0',
    position: 'relative',
    minHeight: 'var(--app-vh)',
    display: 'flex!important',
    margin: '0',
    border: '0',
    color: whiteColor,
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      minHeight: 'fit-content!important',
    },
    '& footer': {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      border: 'none !important',
    },
    '&:before': {
      backgroundColor: 'rgba(' + hexToRgb(theme.palette.brand.main) + ', 0.65)',
    },
    '&:before,&:after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      zIndex: '2',
    },
  }),
}

export default pagesStyle
